var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.58337 7.18487C1.58337 4.09159 4.09098 1.58398 7.18426 1.58398C10.2775 1.58398 12.7851 4.09159 12.7851 7.18487C12.7851 10.2782 10.2775 12.7858 7.18426 12.7858C4.09098 12.7858 1.58337 10.2782 1.58337 7.18487ZM7.18426 0.0839844C3.26255 0.0839844 0.083374 3.26316 0.083374 7.18487C0.083374 11.1066 3.26255 14.2858 7.18426 14.2858C8.87486 14.2858 10.4275 13.6949 11.6469 12.7085L16.9739 18.0355L18.0345 16.9749L12.7076 11.6479C13.6942 10.4284 14.2851 8.87566 14.2851 7.18487C14.2851 3.26316 11.106 0.0839844 7.18426 0.0839844Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchOutlined);
export default __webpack_public_path__ + "static/media/searchOutlined.5f04db1e927bcf1c18803f43231c721a.svg";
export { ForwardRef as ReactComponent };